'use client';
import React from 'react';
import { Col, Container, Placeholder, Row } from 'react-bootstrap';

export default function Skeleton() {
  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col xs={12} md={6}>
          <Placeholder xs={12} style={{ height: '286px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col xs={12} md={6}>
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Row style={{ marginBottom: '20px' }}>
            <Col xs={12} md={6}>
              <Placeholder xs={12} style={{ height: '135px' }} />
            </Col>
            <Col xs={12} md={6}>
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
          </Row>
          <Row style={{ marginBottom: '20px' }}>
            <Col xs={12} md={6}>
              <Placeholder xs={12} style={{ height: '135px' }} />
            </Col>
            <Col xs={12} md={6}>
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6}>
              <Placeholder xs={12} style={{ height: '135px' }} />
            </Col>
            <Col xs={12} md={6}>
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
